import translation from 'i18next'
import * as yup from 'yup'
import {
  validateRecordingNumber,
  validateRecordingNumberForSpecie2,
  validateRecordingNumberForSpecie3,
  validateRecordingNumberForSpecie4,
} from '@/components/forms/ObservationLogFormContainer/validation'
import { mediaSchema, validateMedia } from '@/components/inputs'

const testSpecieDuplication = (
  value: string | undefined,
  context: yup.TestContext
) => {
  if (!!value) {
    const duplicate = Object.keys(context.parent).find(
      (key) =>
        key !== context.path &&
        key.search(/specie\d*$/) >= 0 &&
        context.parent[key] === value
    )

    if (duplicate) {
      const fieldIndex = duplicate.replace('specie', '') || '1'

      return context.createError({
        message: translation.t('errors:validation.specieDuplication', {
          specie: value,
          field:
            translation.t(
              'observationLogs:observation-log.fieldLabels.specie'
            ) + ` ${fieldIndex}`,
        }),
      })
    }
  }

  return true
}

export const schema = yup.object({
  specie: yup.string().required().test(testSpecieDuplication),
  specie2: yup.string().test(testSpecieDuplication),
  specie3: yup.string().test(testSpecieDuplication),
  specie4: yup.string().test(testSpecieDuplication),
  amount: yup.string().required(),
  amount2: yup
    .string()
    .when('specie2', (value, schema) => (value ? schema.required() : schema)),
  amount3: yup
    .string()
    .when('specie3', (value, schema) => (value ? schema.required() : schema)),
  amount4: yup
    .string()
    .when('specie4', (value, schema) => (value ? schema.required() : schema)),
  counting_method: yup.string().required(),
  counting_method2: yup
    .string()
    .when('specie2', (value, schema) => (value ? schema.required() : schema)),
  counting_method3: yup
    .string()
    .when('specie3', (value, schema) => (value ? schema.required() : schema)),
  counting_method4: yup
    .string()
    .when('specie4', (value, schema) => (value ? schema.required() : schema)),
  sound_recordings: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 3,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
  sound_recordings2: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 3,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
  sound_recordings3: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 3,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
  sound_recordings4: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 3,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
  behaviour_notes: yup.string().max(256),
  recording_number: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value))
    .test(validateRecordingNumber),
  recording_number2: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value))
    .test(validateRecordingNumberForSpecie2),
  recording_number3: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value))
    .test(validateRecordingNumberForSpecie3),
  recording_number4: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value))
    .test(validateRecordingNumberForSpecie4),
  observed_at: yup.date().required(),
  photos: mediaSchema,
})
